import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";

const TableRowSectionAddContributors = ({
  isItemSelected,
  row,
  numberType,
  // handleClickRow,
  labelId,
  handleNavigateToDetails,
  handleAddClick,
}) => {
  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        component="th"
        id={labelId}
        scope="row"
        // padding="none"
        onClick={handleNavigateToDetails}
        style={tableTitleFieldStyles}
      >
        {row.firstName}
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        {row.lastName}
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        {row.userName}
      </TableCell>
      <p style={addButtonStyles} onClick={handleAddClick}>
        Add
      </p>
    </TableRow>
  );
};

export default TableRowSectionAddContributors;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  // paddingLeft: 5,
  color: "#00A7CD",
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};

const addButtonStyles = {
  color: "#00A7CD",
  fontSize: "14px",
  fontWeight: "900",
  fontFamily: "Avenir Book, sans-serif",
  background: "transparent",
  paddingLeft: 20,
  cursor: "pointer",
};
